import "./App.scss";
import "./search.scss";
import "./lang.scss";
import allLang from "./utils/lang";
import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  notification,
  Drawer,
} from "antd";
// import logoImg from "./images/logo@2x.png"
import newLogo from "./images/newLogo.png";
import { DownOutlined, LeftOutlined } from "@ant-design/icons";
import { postJson, getJson } from "./utils/fetch";
import { JSEncrypt } from "jsencrypt";

import {
  loginError,
  valicodeError,
  unregisteredresolve,
} from "./utils/index.js";
import config from "./const.js";
import { Link } from "react-router-dom";

let timeChange;
const LoginForm = () => {
  const [form] = Form.useForm(); //获取form实例
  let ref = useRef();
  const [lang, setLang] = useState("");
  const [clientId, setClientId] = useState("")
  const [clientIdList] = useState(['alice_mova'])
  const [voiceType, setVoice] = useState("");
  const [country, setCountry] = useState("")
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [showAccount, setShowAccount] = useState(false);
  const [checkFile, setCheckFile] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [valideCode, setValideCode] = useState("");

  const [time, setTime] = useState(60);
  const [IP, setIP] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState("none");
  const [isOnCliCK, setClick] = useState(true);
  const [isGetCaptcha, setIsGetCaptha] = useState(false);
  const [btnContent, setBtnContent] = useState("");
  const [code, setCode] = useState("");
  const [countryAndArea, setCountryAndArea] = useState("");
  const [chooseArea, chooseAreaCode] = useState(false);

  const [converCountryList, setConvertCountryList] = useState(
    config.countryList
  );
  const [langList, setlangList] = useState(config.langList);
  const [countryList, setCountryList] = useState(config.countryList)
  const [publicKey, savePublicKey] = useState("");
  const [codeKey, saveCodeKey] = useState("");
  const [initCountry, setInitCountry] = useState("");
  const [finalDomain, setDomainUrl] = useState("");
  const [finalDomainSmarthome, setDomainUrlSmarthome] = useState("")
  const [drawerVisible, setVisible] = useState(false);
  const [chooseLang, setChooseLang] = useState(false);
  const [chooseCountry, setChooseCountry] = useState(false)
  const [pageUrl, setPageUrl] = useState("");

  // useEffect(() => {
  //     setShowAccount(sessionStorage.getItem("showAccount"))
  // }, [showAccount])
  //从url获取cliend id 来判断是什么音响 调用什么域名
  useEffect(() => {
    //缓存账号密码以及用户的选择(如果存在)
    const accountItem = sessionStorage.getItem("account");
    const passwordItem = sessionStorage.getItem("password");
    const phoneNumberItem = sessionStorage.getItem("phoneNumber") || "";
    const valideCodeItem = sessionStorage.getItem("valideCode");
    // const showAccountItem = sessionStorage.getItem("showAccount")
    // console.log(showAccountItem)
    const countryItem = 'RU'
    if (countryItem) form.setFieldsValue({ country: countryItem })

    if (accountItem) {
      form.setFieldsValue({ account: accountItem });
      // document.getElementById('account').value = accountItem
    }
    if (passwordItem) {
      form.setFieldsValue({ password: passwordItem });
    }

    if (phoneNumberItem) {
      form.setFieldsValue({ phoneNumber: phoneNumberItem });
      setPhoneNumber(phoneNumberItem);
    }

    if (valideCodeItem) {
      form.setFieldsValue({ valideCode: valideCodeItem });
    }

    // form.setFieldsValue({ checkFile: checkFileItem })
    // setShowAccount(showAccountItem)

    //获取浏览器默认语言来初始化
    let langDefault = navigator.language || navigator.userLanguage; //常规浏览器语言和IE浏览器
    let defaultLang;
    console.log(langDefault, "langDefault");
    //判断是台湾香港不截取 其余截取
    if (
      langDefault.toLowerCase() === "zh-tw" ||
      langDefault.toLowerCase() === "zh-hk"
    ) {
      defaultLang = (
        sessionStorage.getItem("localLang") || langDefault
      ).toLowerCase();
    } else {
      defaultLang =
        sessionStorage.getItem("localLang") || langDefault.substr(0, 2); //截取lang前2位字符
    }

    switch (defaultLang) {
      case "zh":
        convertLanguageLogic("zh");
        break;
      case "en":
        convertLanguageLogic("en");
        break;
      case "ru":
        convertLanguageLogic("ru");
        break;
      case "zh-tw":
        convertLanguageLogic("zh-tw");
        break;
      case "zh-hk":
        convertLanguageLogic("zh-hk");
        break;
      case "de":
        convertLanguageLogic("de");
        break;
      case "ko":
        convertLanguageLogic("ko");
        break;
      case "ja":
        convertLanguageLogic("ja");
        break;
      case "fr":
        convertLanguageLogic("fr");
        break;
      case "es":
        convertLanguageLogic("es");
        break;
      case "it":
        convertLanguageLogic("it");
        break;
      case "pl":
        convertLanguageLogic("pl");
        break;
      case "tr":
        convertLanguageLogic("tr");
        break;
      case "th":
        convertLanguageLogic("th");
        break;
      case "vi":
        convertLanguageLogic("vi");
        break;
      case "id":
        convertLanguageLogic("id");
        break;
      case "uk":
        convertLanguageLogic("uk");
        break;
      default:
        defaultLang = "en";
        convertLanguageLogic("en");
        break;
    }

    convertCountryLogic(countryItem)
    getClientId()
    if (defaultLang) {
      let url = decodeURIComponent(window.location.search);
      setPageUrl(url);
      if (url.indexOf("aligenie") > -1) {
        //天猫精灵
        setVoice(allLang[defaultLang].cat);
      } else if (url.indexOf("dueros_mova") > -1) {
        setVoice(allLang[defaultLang].xiaodu);
      } else if (url.indexOf("alexa") > -1) {
        setVoice(allLang[defaultLang].Alexa);
      } else if (url.indexOf("google") > -1) {
        setVoice(allLang[defaultLang].google);
      } else if (url.indexOf("alice_trouver") > -1) {
        setVoice(allLang[defaultLang].Alice);
      } else if (url.indexOf("alice_mova") > -1) {
        setVoice(allLang[defaultLang].Alice);
      } else if (url.indexOf("moorgen") > -1) {
        setVoice(allLang[defaultLang].moorgen);
      } else if (url.indexOf("vkplatform") > -1) {
        setVoice(allLang[defaultLang].vk);
      } else if (url.indexOf("leelen") > -1) {
        setVoice(allLang[defaultLang].leelen);
      }else if (url.indexOf("hornbach_mova") > -1) {
        setVoice(allLang[defaultLang].hornbach);
      }
      setDomainUrlSmarthome('/dreame-smarthome/')
      setDomainUrl('/dreame-auth/')
      initPage('/dreame-auth/', defaultLang, phoneNumberItem)
    }
  }, []);

  // 设置国家
  const convertCountryLogic = (conutry) => {
    setCountry(conutry)
  }

  const getClientId = () => {
    let clientId = getQueryVariable("client_id") || ""
    setClientId(clientId)
  }


  //根据语言
  const convertLanguageLogic = (lang) => {
    setLang(lang);
    setBtnContent(allLang[lang].getCode);
  };
  //切换语言 变换页面
  const changeLang = () => {
    setChooseLang(true);
  };

  useEffect(() => {
    clearInterval(timeChange);
    return () => clearInterval(timeChange);
  }, []);

  useEffect(() => {
    console.log(time);
    if (time > 0 && time < 60) {
      // setBtnContent('已发送')
      setBtnContent(lang ? `${time}${allLang[lang].second}` : "");
    } else {
      clearInterval(timeChange);
      setBtnDisabled("auto");
      setTime(60);
      setBtnContent(lang ? `${allLang[lang].getCode}` : "");
    }
  }, [time]);

  const initPage = (url, defaultLang, phoneNumberItem) => {
    postJson(url + "publickey").then((res) => {
      // console.log(res.data)
      if (res.data) {
        savePublicKey(res.data);
      }
    });
    getJson(url + "countryCode").then((res) => {
      if (res.success == true) {
        //根据返回的jp 找到对应的手机码
        let simpleCountry = res.data;
        setInitCountry(simpleCountry);
        if (simpleCountry === "CN") {
          //国内校验
          if (phoneNumberItem.length === 11 && phoneNumberItem.charAt(0) == 1) {
            setClick(false);
            setBtnDisabled("auto");
          } else {
            setClick(true);
            setBtnDisabled("none");
          }
          //不可以切换国家

          setIP(false);
        } else {
          //国外不校验不为空即可
          if (phoneNumberItem.length !== 0) {
            setClick(false);
            setBtnDisabled("auto");
          } else {
            setClick(true);
            setBtnDisabled("none");
          }
          setIP(true);
          // 当前国家不是中国的时候过滤掉中国选项
          setConvertCountryList(
            config.countryList.filter((type) => type.short !== "CN")
          );
        }
        config.countryList.map((item, index) => {
          if (item.short == simpleCountry) {
            setCode(item.tel);
            if (defaultLang === "zh") {
              setCountryAndArea(item.name);
            } else {
              setCountryAndArea(item.en);
            }
          }
        });
      }
    });
  };
  const notificationToast = (messageLoad) => {
    notification.open({
      message: messageLoad,
      duration: "2",
      bottom: "20px",
      maxCount: 0,
      placement: "bottomCenter",
      className: "custom-class",
      closeIcon: "",
      style: {
        width: 300,
        height: "auto",
      },
    });
  };

  const onClose = () => {
    setVisible(false);
  };

  //获取验证码
  const getPhoneCaptcha = () => {
    //校验不通过直接不让过
    if (btnDisabled === "none") {
      return;
    }
    console.log(phoneNumber);
    //验证手机号是否输入或者是否正确,通过校验规则才开始倒计时,否则不发
    if (phoneNumber.length == 0) {
      notificationToast(allLang[lang].emptyPhone);
      return;
    }

    //国家为china才校验手机号
    if (code == "86") {
      if (
        !phoneNumber.match(
          /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
        )
      ) {
        notificationToast("手机号格式错误，请重新输入");
        return;
      }
    }
    //发送请求
    let timeNow = new Date().getTime();
    let smsData = {
      phone: phoneNumber,
      phoneCode: code,
      timestamp: timeNow,
      lang: lang,
    };
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(
      "-----BEGIN PUBLIC KEY-----" + publicKey + "-----END PUBLIC KEY-----"
    );
    let encrypted = encrypt.encrypt(JSON.stringify(smsData));
    setIsGetCaptha(true);
    postJson(finalDomain + "oauth/smspublic", { data: encrypted })
      .then((res) => {
        if (res.success && !res.data.unregistered) {
          // 注意，不要使用 setTime(t-1) ： 闭包问题会导致time一直为59

          timeChange = setInterval(() => setTime((t) => --t), 1000);
          setBtnDisabled("none");
          saveCodeKey(res.data.codeKey);
          notificationToast(allLang[lang].sendSuccess);
        } else if (res.success && res.data.unregistered) {
          //手机号未注册 提示
          notificationToast(unregisteredresolve(lang));
          return;
        } else {
          //处理后台返回的错误
          if (res && res.code) {
            // console.log(res)
            notificationToast(valicodeError(res.code, lang));
            return;
          }
        }
      })
      .catch((error) => {
        //网络错误提示
        notificationToast(allLang[lang].sendFailure);
      });
  };
  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  };
  //收取表单登录数据来登录(验证码和密码都是同一个接口)
  const onFinish = (values) => {
    console.log("Success:", values);
    // let hrefUrl = window.location.href + "&t=1";

    // hrefUrl = hrefUrl.substring(hrefUrl.indexOf("client_id"));
    let clientId = getQueryVariable("client_id") || "";
    // alert(clientId, window.location.search, "location")
    console.log(clientId);
    let fetchOptions;

    if (!showAccount) {
      let bean = new FormData();
      let passwordEncrypt = new JSEncrypt();
      passwordEncrypt.setPublicKey(publicKey);
      let passwordEncrypted = encodeURIComponent(
        passwordEncrypt.encrypt(values.password)
      );
      bean.append("grant_type", "password");
      bean.append("scope", "all");
      bean.append("type", "account");
      bean.append("signtype", "pk");
      bean.append("username", values.account);
      bean.append("password", passwordEncrypted);
      bean.append("clientId", clientId);
      bean.append("response_type", "code");
      if (clientIdList.includes(clientId)) {
        bean.append("country", country)
      } else {
        bean.append("country", initCountry)
      }
      bean.append("lang", lang)
      //账号密码登录
      fetchOptions = {
        method: "POST",
        headers: {
          "Tenant-Id": "000002",
          Authorization: "Basic ZHJlYW1lX2FwcHYxOkFQXmR2QHpAU1FZVnhOODg=",
          mode: "cors",
          "Dreame-RLC": "d12671138cc6a559a275fea77a5a2383a68291663dbf8cad-1"
        },
        body: bean,
      };
    } else {
      //验证码登录
      if (!isGetCaptcha) {
        // console.log(res)
        notificationToast(allLang[lang].getCodeFirst);
        return;
      }
      let bean = new FormData();
      bean.append("grant_type", "sms");
      bean.append("scope", "all");
      bean.append("phone_code", code);

      bean.append("phone", values.phoneNumber);
      bean.append("clientId", clientId);
      bean.append("response_type", "code");
      if (clientIdList.includes(clientId)) {
        bean.append("country", country)
      } else {
        bean.append("country", initCountry)
      }
      bean.append("lang", lang)
      fetchOptions = {
        method: "POST",
        headers: {
          "Tenant-Id": "000002",
          "Sms-Code": values.valideCode, //验证码
          "Sms-Key": codeKey,
          Authorization: "Basic ZHJlYW1lX2FwcHYxOkFQXmR2QHpAU1FZVnhOODg=",
          mode: "cors",
          "Dreame-RLC": "d12671138cc6a559a275fea77a5a2383a68291663dbf8cad-1",
        },
        body: bean,
      };
    }
    // alert(finalDomain)

    // alert(finalDomain)
    let url = ""
    // For alice and vk platforms use finalDomainSmarthome, otherwise use finalDomain
    if (clientIdList.includes(clientId)) {
      url = finalDomainSmarthome + "sh/api/auth/token"
    } else {
      url = finalDomain + "oauth/token"
    }
    fetch(url, fetchOptions)
      .then((response) => response.json())
      .then((res) => {
        // alert(res)
        if (res.success == true) {
          // console.log(res.data)
          let code = res.data;

          //解析url进行跳转
          // console.log(window.location.search,'window.location.search')
          let url = decodeURIComponent(window.location.search);
          // let url = window.location.search
          //?redirect_uri=https://open.bot.tmall.com/oauth/callback?skillId=78829&token=MjIwNzg4MTkzNTI0M0FGRUhJTkZEVlE=&client_id=aligenie&response_type=code&state=0.10706107983444269
          let finalUrl = "";
          let callbackHttpUrl;
          let callbackUrl;
          // console.log(url, 'url')
          //根据url里面redirect_uri的位置进行截取得到最终跳转的开头的url
          if (url.indexOf("aligenie") > -1) {
            //天猫精灵的uri
            callbackUrl = url.replace("?redirect_uri=", "");
            callbackHttpUrl = callbackUrl.slice(0, callbackUrl.indexOf("?"));
            console.log(callbackHttpUrl, "callbackHttpUrl");
            finalUrl = finalUrl + callbackHttpUrl + "?";
            callbackUrl = callbackUrl.slice(callbackUrl.indexOf("?") + 1);
            console.log(callbackUrl, "callbackUrl");
            let arrayCallBack = callbackUrl.split("&");
            console.log(arrayCallBack, "arrayCallBack");
            //'skillId=78829', 'token=MjIwNzg4MTkzNTI0M0FGRUhJTkZEVlE=', 'client_id=aligenie', 'response_type=code', 'state=0.08317339299350135'
            arrayCallBack.map((item, index) => {
              if (item.indexOf("skillId") > -1) {
                finalUrl += item;
                console.log(finalUrl, "finalUrl");
              }
              if (item.indexOf("token") > -1) {
                let convertToken = encodeURIComponent(
                  item.replace("token=", "")
                );
                finalUrl += `&token=${convertToken}`;
              }
              // if (item.indexOf("client_id") > -1) {
              //     finalUrl += ('&' + item)
              // }
              // if (item.indexOf("response_type") > -1) {
              //     finalUrl += ('&' + item)
              // }
              if (item.indexOf("state") > -1) {
                finalUrl += "&" + item;
              }
            });
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            window.location.href = finalUrl;
          } else if (url.indexOf("dueros_mova") > -1) {
            //小度的
            //?client_id=dueros&response_type=code&redirect_uri=https://xiaodu.baidu.com/saiya/auth/e9f032484419c7aa86af7586346f24ca&state=753b614df8157acf866d3d8017b4a23f&dueros_uid=753b614df8157acf866d3d8017b4a23f&scope=
            callbackUrl = url.split("redirect_uri=");
            console.log(callbackUrl, "callbackUrl");
            //"https://xiaodu.baidu.com/saiya/auth/e9f032484419c7aa86af7586346f24ca&state=753b614df8157acf866d3d8017b4a23f&dueros_uid=753b614df8157acf866d3d8017b4a23f&scope="
            finalUrl += callbackUrl[1];
            var andSign = finalUrl.indexOf("&");
            // if (finalUrl.indexOf('?') == -1) {
            //     finalUrl = finalUrl.substring(0, andSign) + "?";
            // }
            if (finalUrl.indexOf("?") == -1) {
              finalUrl =
                finalUrl.substring(0, andSign) +
                "?" +
                finalUrl.substring(andSign + 1);
            }
            // https://xiaodu.baidu.com/saiya/auth/e9f032484419c7aa86af7586346f24ca?state=753b614df8157acf866d3d8017b4a23f&dueros_uid=753b614df8157acf866d3d8017b4a23f&scope=&code=z1zohm523u511sp6wsilqwfzzv23ss5r
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            window.location.href = finalUrl;
          } else if (url.indexOf("mihome") > -1) {
            //米家的
            callbackUrl = url.split("redirect_uri="); //通过切割变成数组
            console.log(callbackUrl, "callbackUrl");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            console.log(callbackHttpUrl, "callbackHttpUrl");
            finalUrl = finalUrl + callbackHttpUrl + "?";
            console.log(finalUrl, "finalUrl");
            let mihomeCallbackArray = callbackUrl[1].split("&");

            mihomeCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });

            finalUrl = finalUrl + `&code=${code}`;
            //https://oauth-redirect.api.home.mi.com/r/2147482165?scope=&state=GBDCWlqRZGlZYHu3UpxdOQBdGBKXEHpUDq1O2YurvzWIvFlhDQEYEMt8XDUnvMSlv-OOb2ahWkwYFAr9XPpZ0JU_VM7Va_0ebeeqYK7sAA==&code=81fgetscu4m7j2jg2gh13y6t7h14z337
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          } else if (url.indexOf("jdhome") > -1) {
            //https://yin.dreame.tech/?response_type=code&client_id=jdhome&redirect_uri=https://iotos-accountsandbox.jd.com/third/oAuth&scope=&state=GBDGeDQgdPPX7L0EKhR4FDlYGBKO6SilRzRHpr5Ygg6TPJNcaAEYEEgz4U1BoqIvfq0cXUIqGREYFJy0pkDp-zI3Ft5tJgstTgKTct8LAA==
            callbackUrl = url.split("redirect_uri=");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            finalUrl = finalUrl + callbackHttpUrl + "?";
            let jdhomeCallbackArray = callbackUrl[1].split("&");

            jdhomeCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });

            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          } else if (url.indexOf("alexa") > -1) {
            callbackUrl = url.split("redirect_uri=");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            finalUrl = finalUrl + callbackHttpUrl + "?";
            let AlexaCallbackArray = callbackUrl[1].split("&");

            AlexaCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          } else if (url.indexOf("hornbach_mova") > -1) {
            callbackUrl = url.split("redirect_uri=");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            finalUrl = finalUrl + callbackHttpUrl + "?";
            let hornbachCallbackArray = callbackUrl[1].split("&");

            hornbachCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          }else if (url.indexOf("vkplatform") > -1) {
            callbackUrl = url.split("redirect_uri=");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            finalUrl = finalUrl + callbackHttpUrl + "?";
            let AlexaCallbackArray = callbackUrl[1].split("&");

            AlexaCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          } else if (url.indexOf("leelen") > -1) {
            callbackUrl = url.split("redirect_uri=");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            finalUrl = finalUrl + callbackHttpUrl + "?";
            let leelenCallbackArray = callbackUrl[1].split("&");

            leelenCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          } else if (url.indexOf("alice_trouver") > -1) {
            //俄罗斯alice登录授权
            //?scope=1&state=https://social.yandex.ru/broker2/authz_in_web/09ecb7f961804d88aba9228b56c07c44/callback&
            //https://social.yandex.net/broker/redirect&response_type=code&client_id=alice
            callbackUrl = url.split("redirect_uri=");
            // alert(callbackUrl, 'callbackUrl')
            if (
              Array.isArray(callbackUrl) &&
              callbackUrl[1] &&
              callbackUrl[0]
            ) {
              if (callbackUrl[1].indexOf("?") == -1) {
                //alice授权需要拼接?
                let andSign = callbackUrl[1].indexOf("&");
                callbackHttpUrl =
                  callbackUrl[1].substring(0, andSign) +
                  "?" +
                  callbackUrl[1].substring(andSign + 1);
              }

              if (callbackUrl[0].indexOf("?") != -1) {
                let fistPart = callbackUrl[0].indexOf("?");
                let urlState = callbackUrl[0].substring(fistPart + 1);
                let urlStateArray = urlState.split("&");
                // alert(urlStateArray)
                //scope=1,state=https://social.yandex.ru/broker2/authz_in_web/09ecb7f961804d88aba9228b56c07c44/callback,
                urlStateArray.map((item, index) => {
                  if (item.indexOf("state") > -1) {
                    let convertState = encodeURIComponent(
                      item.replace("state=", "")
                    );
                    callbackHttpUrl += "&" + `state=${convertState}`;
                  }
                  if (item.indexOf("scope") > -1) {
                    callbackHttpUrl += "&" + item;
                  }
                });
                // callbackHttpUrl += ('&' + callbackUrl[0].substring(fistPart+1))
                // alert(callbackHttpUrl)
              }
            }
            finalUrl = finalUrl + callbackHttpUrl;
            finalUrl = finalUrl + `&code=${code}`;
            // alert(finalUrl, 'finalUrl')
            window.location.href = finalUrl;
          }else if (url.indexOf("alice_mova") > -1) {
            //俄罗斯alice登录授权
            //?scope=1&state=https://social.yandex.ru/broker2/authz_in_web/09ecb7f961804d88aba9228b56c07c44/callback&
            //https://social.yandex.net/broker/redirect&response_type=code&client_id=alice
            callbackUrl = url.split("redirect_uri=");
            // alert(callbackUrl, 'callbackUrl')
            if (
                Array.isArray(callbackUrl) &&
                callbackUrl[1] &&
                callbackUrl[0]
            ) {
              if (callbackUrl[1].indexOf("?") == -1) {
                //alice授权需要拼接?
                let andSign = callbackUrl[1].indexOf("&");
                callbackHttpUrl =
                    callbackUrl[1].substring(0, andSign) +
                    "?" +
                    callbackUrl[1].substring(andSign + 1);
              }

              if (callbackUrl[0].indexOf("?") != -1) {
                let fistPart = callbackUrl[0].indexOf("?");
                let urlState = callbackUrl[0].substring(fistPart + 1);
                let urlStateArray = urlState.split("&");
                // alert(urlStateArray)
                //scope=1,state=https://social.yandex.ru/broker2/authz_in_web/09ecb7f961804d88aba9228b56c07c44/callback,
                urlStateArray.map((item, index) => {
                  if (item.indexOf("state") > -1) {
                    let convertState = encodeURIComponent(
                        item.replace("state=", "")
                    );
                    callbackHttpUrl += "&" + `state=${convertState}`;
                  }
                  if (item.indexOf("scope") > -1) {
                    callbackHttpUrl += "&" + item;
                  }
                });
                // callbackHttpUrl += ('&' + callbackUrl[0].substring(fistPart+1))
                // alert(callbackHttpUrl)
              }
            }
            finalUrl = finalUrl + callbackHttpUrl;
            finalUrl = finalUrl + `&code=${code}`;
            // alert(finalUrl, 'finalUrl')
            window.location.href = finalUrl;
          } else if (url.indexOf("moorgen") > -1) {
            callbackUrl = url.split("redirect_uri=");
            callbackHttpUrl = callbackUrl[1].slice(
              0,
              callbackUrl[1].indexOf("&")
            );
            finalUrl = finalUrl + callbackHttpUrl + "?";
            let moorgenCallbackArray = callbackUrl[1].split("&");

            moorgenCallbackArray.map((item, index) => {
              if (item.indexOf("state") > -1) {
                let convertState = encodeURIComponent(
                  item.replace("state=", "")
                );
                finalUrl += `state=${convertState}`;
              }
            });
            finalUrl = finalUrl + `&code=${code}`;
            console.log(finalUrl, "finalUrl");
            // debugger;
            window.location.href = finalUrl;
          } else {
            // 谷歌的登录授权
            if (url.indexOf("google") > -1) {
              if (url.indexOf("redirect_uri=")) {
                callbackUrl = url.split("redirect_uri=");
              }
              // alert(callbackUrl, 'callbackUrl')
              if (
                Array.isArray(callbackUrl) &&
                callbackUrl[1] &&
                callbackUrl[0]
              ) {
                if (callbackUrl[1].indexOf("?") == -1) {
                  //谷歌授权需要拼接?
                  let andSign = callbackUrl[1].indexOf("&");
                  callbackHttpUrl =
                    callbackUrl[1].substring(0, andSign) +
                    "?" +
                    callbackUrl[1].substring(andSign + 1);
                }
              }
              finalUrl = finalUrl + callbackHttpUrl;
              finalUrl = finalUrl + `&code=${code}`;
              // alert(finalUrl, 'finalUrl')
              window.location.href = finalUrl;
            }
          }
          // //拼接code
          // finalUrl = finalUrl + `&code=${code}`
          // console.log(finalUrl, 'finalUrl')
          // // debugger;
          // window.location.href = finalUrl;
        } else {
          //处理后台返回的错误
          if (
            res &&
            res.error_description &&
            res.error_description !== "exceed max login attempts"
          ) {
            notificationToast(loginError(res.error_description, lang));
            return;
          } else if (
            res &&
            res.error_description === "exceed max login attempts"
          ) {
            //处理多次账号密码不对的错误(drawer)
            setVisible(true);
            return;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //账号
  const onChangeAccount = (e) => {
    setAccount(e.target.value);
    sessionStorage.setItem("account", e.target.value);
  };

  //密码
  const onChangePassword = (e) => {
    setPassword(e.target.value);
    sessionStorage.setItem("password", e.target.value);
  };
  // 选择同意隐私协议
  const onChangeCheck = (e) => {
    // console.log(e)
    setCheckFile(e.target.checked);
    // sessionStorage.setItem("checkFile", e.target.checked)
  };
  //切换登录方式
  const trigger = () => {
    setShowAccount(!showAccount);
    // ref.current = !showAccount
    // sessionStorage.setItem("showAccount", !showAccount)
  };
  //输入手机号
  const onChangePhoneNumber = (e) => {
    if (IP) {
      //国外不校验不为空即可
      if (e.target.value.length !== 0) {
        setClick(false);
        setBtnDisabled("auto");
      } else {
        setClick(true);
        setBtnDisabled("none");
      }
    } else {
      //国内校验
      if (e.target.value.length === 11 && e.target.value.charAt(0) == 1) {
        setClick(false);
        setBtnDisabled("auto");
      } else {
        setClick(true);
        setBtnDisabled("none");
      }
    }

    setPhoneNumber(e.target.value);
    sessionStorage.setItem("phoneNumber", e.target.value);
  };
  //手机验证码
  const onChangeValideCode = (e) => {
    setValideCode(e.target.value);
    sessionStorage.setItem("valideCode", e.target.value);
  };

  const goback = () => {
    chooseAreaCode(!chooseArea);
  };


  const serachCountry = (e) => {
    //模糊查询国家
    let value = e.target.value
    setCountryList(value ? config.countryList.filter((type) => (type.en.toLocaleLowerCase()).includes(value.toLocaleLowerCase())) : config.countryList)
  }


  const serach = (e) => {
    //模糊查询国家
    let value = e.target.value;
    // console.log(value)
    if (lang === "zh") {
      setConvertCountryList(
        value
          ? config.countryList.filter((type) => type.name.includes(value))
          : config.countryList
      );
    } else {
      setConvertCountryList(
        value
          ? config.countryList.filter((type) =>
              type.en.toUpperCase().includes(value.toUpperCase())
            )
          : config.countryList
      );
    }
  };

  const chooseSingalCountry = (e, item) => {
    //切换国家选择对应的code
    chooseAreaCode(!chooseArea);
    if (lang === "zh") {
      setCountryAndArea(item.name);
      //切换后对应的也要改
      setInitCountry(item.short);
    } else {
      setCountryAndArea(item.en);
      //切换后对应的也要改
      setInitCountry(item.short);
    }

    setCode(item.tel);
  };

  const afterLetter = (
    <span
      onClick={getPhoneCaptcha}
      style={{
        pointerEvents: btnDisabled,
        color: isOnCliCK ? "#cccccc" : "rgba(0, 0, 0, 0.85)",
      }}
    >
      {btnContent || (lang ? allLang[lang].getCode : "")}
    </span>
  );

  const addonContainer = <span>+{code}</span>;

  const cancelChooseLang = () => {
    setChooseLang(false);
  };

  const cancelChooseCountry = () => {
    setChooseCountry(false)
    setCountryList(config.countryList)
  }

  const chooseOneLang = (e, item) => {
    setChooseLang(false);
    setLang(item.value);
    //切换语言将选择的语言存起来 做数据持久化
    sessionStorage.setItem("localLang", item.value);

    setBtnContent(allLang[item.value].getCode);
    if (item.value == "zh") {
      config.countryList.map((item1, index) => {
        if (item1.short == initCountry) {
          setCountryAndArea(item1.name);
        }
      });
    } else {
      config.countryList.map((item2, index) => {
        if (item2.short == initCountry) {
          setCountryAndArea(item2.en);
        }
      });
    }

    //切换语言切换音箱名字
    if (pageUrl.indexOf("aligenie_mova") > -1) {
      //天猫精灵
      setVoice(allLang[item.value].cat);
    } else if (pageUrl.indexOf("dueros_mova") > -1) {
      setVoice(allLang[item.value].xiaodu);
    } else if (pageUrl.indexOf("alexa_mova") > -1) {
      setVoice(allLang[item.value].Alexa);
    } else if (pageUrl.indexOf("google_mova") > -1) {
      setVoice(allLang[item.value].google);
    } else if (pageUrl.indexOf("alice_mova") > -1) {
      setVoice(allLang[item.value].Alice);
    } else if (pageUrl.indexOf("moorgen_mova") > -1) {
      setVoice(allLang[item.value].moorgen);
    } else if (pageUrl.indexOf("vkplatform_mova") > -1) {
      setVoice(allLang[item.value].vk);
    } else if (pageUrl.indexOf("leelen_mova") > -1) {
      setVoice(allLang[item.value].leelen);
    }
  };

  const chooseOneCountry = (e, item) => {
    setChooseCountry(false)
    setCountry(item.short)
    setCountryList(config.countryList)
  }


  const language = (lang) => {
    let oneLangguage;
    switch (lang) {
      case "zh":
        oneLangguage = "中文简体";
        break;
      case "en":
        oneLangguage = "English";
        break;
      case "ru":
        oneLangguage = "русский";
        break;
      case "zh-tw":
        oneLangguage = "繁體中文(台灣)";
        break;
      case "zh-hk":
        oneLangguage = "繁體中文(香港)";
        break;
      case "de":
        oneLangguage = "Deutsch";
        break;
      case "ko":
        oneLangguage = "한국어";
        break;
      case "ja":
        oneLangguage = "日本語";
        break;
      case "fr":
        oneLangguage = "français";
        break;
      case "es":
        oneLangguage = "español";
        break;
      case "it":
        oneLangguage = "italiano";
        break;
      case "pl":
        oneLangguage = "polski";
        break;
      case "tr":
        oneLangguage = "Türkçe";
        break;
      case "th":
        oneLangguage = "ไทย";
        break;
      case "vi":
        oneLangguage = "Tiếng Việt";
        break;
      case "id":
        oneLangguage = "Bahasa Indonesia";
        break;
      case "uk":
        oneLangguage = "Українська Мова";
        break;
      default:
        break;
    }
    return <span>{oneLangguage}</span>;
  };
  return (
    <div>
      {chooseCountry ? (
                <div className='chooseLangContainer'>
          <span onClick={cancelChooseCountry} className='leftStyle'>
            <LeftOutlined />
          </span>

                  <div className='conutryList'>
                    <Input
                        placeholder={allLang[lang].select_location_tip}
                        onChange={serachCountry}
                        className="countrySearch"
                    />
                    {countryList.map((item, index) => {
                      return (
                          <div className='singalConutry' key={index} onClick={(e) => chooseOneCountry(e, item)}>
                            {item.en}
                          </div>
                      )
                    })}
                  </div>
                </div>
            ) :
            chooseLang && lang ? (
        <div className="chooseLangContainer">
          <span onClick={cancelChooseLang} className="leftStyle">
            <LeftOutlined />
          </span>
          <h2 className="langTitle">{allLang[lang].chooseLang}</h2>

          <div className="langList">
            {langList.map((item, index) => {
              return (
                <div
                  className="singalLang"
                  key={index}
                  onClick={(e) => chooseOneLang(e, item)}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      ) : chooseArea && lang && IP ? (
        <div className="search">
          <div className="searchButton">
            <span onClick={goback} className="leftStyle">
              <LeftOutlined />
            </span>{" "}
            <Input placeholder={allLang[lang].search} onChange={serach} />
          </div>
          <h1 className="countryAndArea">{allLang[lang].region}</h1>

          <div className="countryList">
            {converCountryList.map((item, index) => {
              return (
                <div
                  className="singalArea"
                  key={index}
                  onClick={(e) => chooseSingalCountry(e, item)}
                >
                  {lang === "zh" ? item.name : item.en}
                </div>
              );
            })}
          </div>
        </div>
      ) : lang ? (
        <div className="App">
          <div className="lang">
            <div className="selectLang" onClick={changeLang}>
              {language(lang)}&nbsp;&nbsp;
              <DownOutlined />
            </div>
          </div>
          {/* {showAccount} */}
          {/* <Input id="account" allowClear placeholder={allLang[lang].phoneEmailId} className='account' onChange={onChangeAccount} value={account} /> */}
          <div className="logoDiv">
            <img src={newLogo} alt="" className="logoImg"></img>
          </div>
          <div className="title">
            <span className="titleName">{allLang[lang].title}</span>
          </div>
          <div className="loginForm">
            <Row type="flex" justify="center" align="middle">
              <Col span={24}>
                <Form
                  name="basic"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  form={form}
                  autoComplete="off"
                >
                  {!showAccount ? (
                    <div>
                      {clientIdList.includes(clientId) ? (<Form.Item label='' name='country' wrapperCol={{ offset: 1, span: 8 }}>
                        <div>{country}&nbsp;&nbsp;
                          <DownOutlined onClick={() => setChooseCountry(true)} />
                        </div>
                      </Form.Item>) : null}

                      <Form.Item
                        label=""
                        name="account"
                        rules={[
                          {
                            required: true,
                            message: allLang[lang].validPhoneEmailId,
                          },
                        ]}
                      >
                        <Input
                          id="account"
                          allowClear
                          placeholder={allLang[lang].phoneEmailId}
                          className="account"
                          onChange={onChangeAccount}
                          value={account}
                        />
                      </Form.Item>

                      <Form.Item
                        label=""
                        name="password"
                        style={{ marginBottom: "15px" }}
                        rules={[
                          { required: true, message: allLang[lang].password },
                        ]}
                      >
                        <Input.Password
                          placeholder={allLang[lang].password}
                          className="password"
                          value={password}
                          onChange={onChangePassword}
                        />
                      </Form.Item>

                      <Form.Item
                        wrapperCol={{ offset: 1, span: 8 }}
                        style={{ marginBottom: "54px" }}
                      >
                        <span className="phoneCode" onClick={trigger}>
                          {allLang[lang].codeLogin}
                        </span>
                      </Form.Item>
                    </div>
                  ) : (
                    <div>
                      <div className="selectCountry">
                        <Form.Item wrapperCol={{ offset: 1, span: 8 }}>
                          <div className="select" onClick={chooseAreaCode}>
                            {countryAndArea}&nbsp;&nbsp;
                            <DownOutlined />
                          </div>
                        </Form.Item>
                      </div>

                      <Form.Item
                        label=""
                        name="phoneNumber"
                        //required: true, message: '请输入手机号码!'
                        rules={[
                          {
                            required: true,
                            message: allLang[lang].validPhoneNumer,
                          },
                        ]}
                      >
                        <Input
                          style={{ height: "44px", borderRadius: "22px" }}
                          addonBefore={addonContainer}
                          placeholder={allLang[lang].phoneNumber}
                          className="phoneNumber"
                          allowClear
                          onChange={onChangePhoneNumber}
                          value={phoneNumber}
                        />
                      </Form.Item>

                      <Form.Item
                        label=""
                        name="valideCode"
                        rules={[
                          { required: true, message: allLang[lang].validCode },
                        ]}
                      >
                        <Input
                          style={{ height: "44px", borderRadius: "22px" }}
                          addonAfter={afterLetter}
                          placeholder={allLang[lang].code}
                          className="valideCode"
                          onChange={onChangeValideCode}
                          value={valideCode}
                        />
                      </Form.Item>

                      <Form.Item
                        wrapperCol={{ offset: 1, span: 8 }}
                        style={{ marginBottom: "54px" }}
                      >
                        <span className="phoneCode" onClick={trigger}>
                          {allLang[lang].accountPasswordLogin}
                        </span>
                      </Form.Item>
                    </div>
                  )}
                  <Form.Item
                    name="checkFile"
                    wrapperCol={{ offset: 0, span: 8 }}
                    className="checkboxChoose"
                  >
                    <div>
                      {/* onClick={goGeneral} */}
                      <Checkbox
                        checked={checkFile}
                        onChange={onChangeCheck}
                      ></Checkbox>
                      <span className="normol">
                        &nbsp;&nbsp;{allLang[lang].pleaseCheck}
                      </span>
                      &nbsp;
                      <a
                        href={
                          "https://protocol.dreame.tech/r9407/" +
                          lang +
                          "/general_license.html"
                        }
                        className="userSchedul"
                      >
                        {allLang[lang].userShedule}
                      </a>
                      &nbsp;
                      <span className="normolAnd">{allLang[lang].and}</span>
                      &nbsp;
                      <a
                        href={
                          "https://protocol.dreame.tech/r9407/" +
                          lang +
                          "/general_privacyPolicy.html"
                        }
                        className="pricity"
                      >
                        {allLang[lang].privary}
                      </a>
                      <span className="normolAnd">
                        {allLang[lang].addtionnal}
                      </span>
                      <div>
                        {/* 路由组件，注意这里path没有. */}

                        {/* <Route path='/enLicense' component={enLicense} /> */}
                      </div>
                    </div>
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{ offset: 0, span: 16 }}
                    className="submitForm"
                  >
                    <Button
                      disabled={checkFile ? false : true}
                      type="primary"
                      htmlType="submit"
                      className="submit"
                    >
                      {allLang[lang].login}
                    </Button>
                  </Form.Item>

                  {voiceType !== "Amazon Alexa" ? (
                    <Form.Item wrapperCol={{ offset: 0, span: 16 }}>
                      <div className="agree">
                        <div className="agreeTitle">
                          <span className="agreeContent">
                            {allLang[lang].loginDescPart1}&nbsp;
                          </span>
                          <span className="voiceType">{voiceType}</span>&nbsp;
                          <span className="agreeContent">
                            {allLang[lang].loginDescPart12}
                          </span>
                        </div>
                      </div>
                    </Form.Item>
                  ) : (
                    ""
                  )}
                </Form>
              </Col>
            </Row>
          </div>
          <div className="drawStyle">
            <Drawer
              title=""
              placement="bottom"
              onClose={onClose}
              visible={drawerVisible}
            >
              <p
                className="knowContent"
                style={{ width: "80%", margin: "0 auto 20px" }}
              >
                {allLang[lang].loginTryMany}
              </p>
              <div className="knowError">
                <Button type="primary" className="know" onClick={onClose}>
                  {allLang[lang].know}
                </Button>
              </div>
            </Drawer>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default LoginForm;
